<template>
  <div class="terms">
    <template v-if="termsContent">
      <div v-if="isAdmin" class="mb-4">
        <v-btn color="primary" v-if="isEditing" @click="saveEdits">Save</v-btn>
        <v-btn v-if="isEditing" class="ml-4" @click="isEditing = false">Cancel</v-btn>
        <v-btn v-if="!isEditing" @click="isEditing = true">Edit as Admin</v-btn>
      </div>
      <wysiwyg v-if="isEditing" v-model="editHtml" />
      <div v-if="!isEditing" v-html="termsContent"></div>
    </template>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

export default {
  name: 'Terms',
  data: () => ({
    termsContent: null,
    isEditing: false,
    editHtml: '',
  }),
  mounted() {
    firebase.database().ref('terms').once('value').then(snapshot => {
      this.termsContent = snapshot.val() ? snapshot.val() : null
    })
  },
  computed: {
    isAdmin() {
      const email = firebase.auth().currentUser.email
      return ['thatericsmith@gmail.com', 'jason@gopsychometric.com', 'nathan@gopsychometric.com'].includes(email)
    },
    userName() {
      return firebase.auth().currentUser.displayName
    },
  },
  methods: {
    saveEdits() {
      this.termsContent = this.editHtml
      firebase.database().ref('terms').set(this.termsContent)
      firebase.database().ref('termsChangedAt').set(Date.now())
      this.isEditing = false
    },
  },
  watch: {
    isEditing(edit) {
      if (edit) {
        this.editHtml = this.termsContent
      }
    }
  }
}
</script>
<style>
.terms p, .terms h1, .terms h2, .terms h3, .terms h4, .terms h5, .terms h6, .terms li {
  color: black;
}
.terms {
  padding: 30px;
  text-align: left;
}


.editr {
  border: 1px solid #e4e4e4;
  width: 100%;
}
.editr--toolbar {
  background: #f6f6f6;
  border-bottom: 1px solid #e4e4e4;
  position: fixed;
  width: 100%;
  top:0;
  left: 0;
  display: flex;
  height: 32px;
}
.editr--toolbar a {
  display: inline-block;
  width: 8vw;
  max-width: 32px;
  height: 32px;
  color: #333;
  fill: #333;
  cursor: pointer;
  text-align: center;
  line-height: 1;
}
.editr--toolbar a:hover {
  background: rgba(0,0,0,0.1);
}
.editr--toolbar a:active {
  background: rgba(0,0,0,0.2);
}
.editr--toolbar a svg {
  width: 16px;
  height: 16px;
  margin: 8px auto;
}
.editr--toolbar a svg path {
  fill: inherit;
}
.editr--toolbar a.vw-btn-separator {
  width: 1px;
  margin: 0 8px;
}
.editr--toolbar a.vw-btn-separator:hover {
  background: initial;
  cursor: default;
}
.editr--toolbar a.vw-btn-separator i.vw-separator {
  border-left: 1px solid rgba(0,0,0,0.1);
  height: 100%;
  position: absolute;
  width: 1px;
}
.editr--toolbar .dashboard {
  width: 100%;
  position: absolute;
  top: 32px;
  left: 0;
  text-align: left;
  padding: 8px 16px;
  background: rgba(255,255,255,0.95);
  border: 1px solid #f6f6f6;
}
.editr--content {
  min-height: 150px;
  padding: 12px 8px 16px 8px;
  font-family: inherit;
  color: inherit;
  overflow-y: auto;
}
.editr--content[contenteditable=true]:empty:before {
  content: attr(placeholder);
  color: rgba(0,0,0,0.3);
  display: block; /* For Firefox */
}
.editr--content img {
  max-width: 100%;
}
.editr--content table {
  width: 100%;
  border-collapse: collapse;
}
.editr--content table th {
  text-align: left;
}
.editr--content table th,
.editr--content table td {
  border: 1px solid #ddd;
  padding: 2px;
}
.editr--content:focus {
  outline: 0;
}
@media screen and (max-width: 320px) {
  .editr--toolbar a {
      margin: 0 2px;
  }
  .editr--toolbar a.vw-btn-separator {
      display: none;
  }
}
</style>
